<div class="bg-white px-4 py-2">
  <form [formGroup]="filterForm">
    <div
      class="flex-wrap align-items-center"
      style="
        grid-gap: 15px;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
      "
    >
      <div>
        <p-dropdown
          class="filter-multiselect narrow-multiselect"
          [options]="daysAheadOptions"
          formControlName="daysAhead"
        ></p-dropdown>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="All Suppliers"
          [options]="suppliers"
          formControlName="supplierIds"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="All Supplier Types"
          [options]="supplierContractTypes"
          formControlName="supplierContractTypes"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="All Customers"
          [options]="customers"
          formControlName="customerIds"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="Customer Priority"
          [options]="priorities"
          formControlName="priorities"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="Service Type"
          [options]="serviceTypes"
          formControlName="serviceTypes"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="Task Status"
          [options]="taskStatuses"
          formControlName="taskStatuses"
        ></p-multiSelect>
      </div>

      <div class="flex gap-2">
        <div class="flex-shrink-1">
          <button class="button-style" type="button" (click)="search()">
            <i class="fa fa-search"></i>&nbsp;Search
          </button>
        </div>

        <div class="flex-shrink-1">
          <button
            class="button-style ui-button-tertiary transparent"
            type="button"
            (click)="resetFilters()"
          >
            <i class="fa fa-undo"></i>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="px-4 py-2">
  <div class="mb-2 bold-text" *ngIf="!isLoading">
    Showing {{ data?.total ?? 0 }} matching {{ (data?.total ?? 0) === 1 ? 'task' : 'tasks' }}
  </div>

  <p-table
    [value]="data?.tasks ?? []"
    [lazy]="true"
    (onLazyLoad)="loadLazy($event)"
    [loading]="isLoading"
    [paginator]="true"
    [rows]="pageSize"
    [totalRecords]="data?.total ?? 0"
    [rowsPerPageOptions]="[25, 50, 100]"
    [first]="pageIndex * pageSize"
    styleClass="unscheduled-tasks-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 140px">Latest Pickup</th>
        <th style="width: 120px">Vehicle</th>
        <th style="width: 130px">Job</th>
        <th>Customer</th>
        <th>Supplier</th>
        <th>Route</th>
        <th class="status-cell" style="width: 160px">Task Status</th>
        <th style="width: 150px; min-width: 150px">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-task>
      <tr [class.overdue-row]="isOverdue(task)">
        <td>
          <div class="bold-text">{{ task.latestCustomerPickup | datex : 'ddd, DD MMM' }}</div>
          <div
            class="text-sm"
            [class.text-red-600]="isOverdue(task)"
            [class.text-orange-600]="isDueToday(task)"
            [class.text-gray-600]="!isOverdue(task) && !isDueToday(task)"
          >
            {{ dueLabel(task) }}
          </div>
        </td>

        <td>
          <a
            class="text-blue-500 bold-text"
            target="_blank"
            href="/app/jobscreen/{{ task.jobId }}"
            >{{ task.vehicleReg }}</a
          >
        </td>

        <td>
          <a
            class="text-blue-500 bold-text"
            target="_blank"
            href="/app/jobscreen/{{ task.jobId }}"
            >{{ task.jobNumber }}</a
          >
        </td>

        <td>
          <a
            class="text-blue-500"
            target="_blank"
            href="/app/customer-information/{{ task.customerId }}"
            >{{ task.customerName }}</a
          >
          <span class="text-gray-600" *ngIf="task.customerPriority">
            ({{ AMPriorityEnum[task.customerPriority] }})</span
          >
        </td>

        <td>
          <a
            class="text-blue-500"
            target="_blank"
            href="/app/supplier-information/{{ task.supplierId }}"
            >{{ task.supplierName }}</a
          >
          <div class="text-sm text-gray-600" *ngIf="task.supplierPhoneNumber">
            {{ task.supplierPhoneNumber }}
          </div>
        </td>

        <td>
          <div class="flex align-items-center">
            <span class="bold-text">{{ task.pickupLocation }}</span>
            <i class="fa fa-arrow-right mx-2"></i>
            <span class="bold-text">{{ task.dropoffLocation }}</span>
          </div>
          <div class="text-sm text-gray-600">{{ task.movementType }}</div>
        </td>

        <td class="status-cell">
          <pill textColour="text-gray-700">
            <span>{{ task.taskStatus || 'No Status' }}</span>
          </pill>
        </td>

        <td class="actions-cell">
          <button
            pButton
            type="button"
            label="Set Schedule"
            class="ui-button-secondary"
            pTooltip="Edit Driver Schedule"
            (click)="openScheduleEditor(task)"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center py-4">
          <h4 class="my-0">
            No unscheduled tasks found matching the criteria. Change the filters and try again.
          </h4>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="showDateTimeSelector" [modal]="true" header="Edit Driver Schedule">
  <div *ngIf="editingTask != null">
    <p class="mt-0">
      <span class="bold-text">{{ editingTask.vehicleReg }}</span>
      — {{ editingTask.jobNumber }}, {{ editingTask.supplierName }}
    </p>

    <app-date-time-selector
      [(pickupDateTime)]="currentEarliestPickup"
      [(dropoffDateTime)]="currentEarliestDropoff"
      [customerEarliestPickup]="editingTask.earliestCustomerPickup"
      [customerEarliestDropoff]="editingTask.earliestCustomerDropoff"
      [customerLatestPickup]="editingTask.latestCustomerPickup"
      [customerLatestDropoff]="editingTask.latestCustomerDropoff"
    ></app-date-time-selector>
  </div>

  <p-footer>
    <button
      pButton
      type="button"
      label="Save"
      class="ui-button-primary"
      [disabled]="isSavingSchedule"
      (click)="saveDriverSchedule()"
    ></button>
  </p-footer>
</p-dialog>
